/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { PlaidService } from '../../../shared/services/plaid.service';

@Component({
  selector: 'ns-funding-choices-streamline',
  template: require('./funding-choices-streamline.component.html')
})

export class FundingChoicesStreamlineComponent extends BaseRoute {

  isIRA = false;

  constructor(
    injector: Injector,
    plaid: PlaidService) {
    super(injector);
    this.plaid = plaid;


    //below is dummy for testing
    // this.depositAccounts = [{
    //   number: '1050137940',
    //   name: 'WFLCV GARCIA Jr.',
    //   value: '380.54',
    //   balance: '4609.2',
    //   status: 'Active',
    //   type: 'DDA',
    //   interest: '0.66',
    //   isIra: false
    // }];
    //dummy end
  }

  ngOnInit() {
    this.isIRA = this.flowManager.isIra;
    this.depositAccounts = this.appActions.getData('Streamline').accounts;
    this._streamlineAllyAccounts();

    // Get the names on the account
    this.appInfo = this.appActions.getData('ApplicationInformation');
    this.investAccount = this.appActions.getData('DepositFunds.to');
    this.form.inputs.investAccount.noneditable = (this.investAccount) ? this.investAccount : '';
    // For testing
    this.appActions.setData('auth.authed', true);
    // this.appInfo = {
    //   signature: {
    //     name: 'Mike A Jason' // Use 'Alberta Charleson Bobbeth' for test plaid user
    //   }
    // };
    const names = [this.appInfo.signature.name];
    if (this.appInfo.jointAccountSignature != null) {
      names.push(this.appInfo.jointAccountSignature.name);
    }
    // Add primary name to funding data
    this.name = this.appInfo.signature.name;
    this.appActions.setData('FundAccount.accountHoldersName', this.name);


    this.plaid.onSuccess((publicToken, argMetadata) => {
      this.modal.plaidLoadingModel(); // Maybe this should be in the plaid service

      const metadata = {
        request_id: this.request_id,
        public_token: argMetadata.public_token,
        id: argMetadata.account.id,
        bankName: argMetadata.institution.name.replace(/[^a-zA-Z1-9 ]/g, '')
      };

      this.appProxy.plaidInit({ publicToken, metadata, names }, resp => {
        this.appActions.setData('FundAccount', resp.result);

        if (resp.result.blackListed === true) return this._blackListed();
        if (resp.status === 401) return this._badName(resp.result);
        if (resp.result.showAbaRouting === true) return this._showABARouting();
        if (resp.result.plaidSuccess === true) return this._passed();
      });
    });

    // Plaid error logging
    this.plaid.onEvent((eventName, metadata) => {
      if (eventName === 'HANDOFF') {
        this.request_id = metadata.request_id;
      }

      if (eventName === 'ERROR') {
        this.tempObject = metadata;
      }

      if (eventName === 'TRANSITION_VIEW' && metadata.request_id !== null && metadata.request_id !== this.request_id && this.tempObject !== undefined) {
        this.request_id = metadata.request_id;
        this.tempObject.request_id = metadata.request_id;
        this.appProxy.plaidError(this.tempObject, () => delete this.tempObject);
      }

      if (eventName === 'SELECT_INSTITUTION') {
        // REMOVE THIS WHEN PLAID SUPPORTS CAPITAL ONE AGAIN
        // Check for Capital One selection (not currently supported by Plaid)
        if (metadata.institution_id === 'ins_9') {
          this.appActions.setData('FundAccount.bankName', metadata.institution_name);
          this.plaid.close();
          this.router.navigate(['/fund-account']);
        }
      }
    });

    this.plaid.onExit((err, metadata) => {
      if (metadata.status === 'institution_not_found') {
        this.appActions.clearData('FundAccount');
        this.appActions.setData('FundAccount.accountHoldersName', this.name);
        this.router.navigate(['/fund-account']);
      } else {
        this._resetSelectOptions();
      }
    });
  }

  _blackListed() {
    this.blackListed = true;
    this.modal.closeModal();
  }

  _badName(data) {
    if (data.nameFailout === true) {
      this.appActions.setData('FundAccount.nameFailout', true);
      this.modal.closeModal('verify-ach-profile-failed');
      return;
    }
    this.isError = true;
    this.modal.closeModal();
  }

  _showABARouting() {
    this.modal.closeModal('fund-aba-routing');
  }

  _passed() {
    this.modal.closeModal('verify-ach-profile-passed');
  }

  _resetSelectOptions() {
    const allyAccount = this.form.inputs.selectedAccount;
    this.appActions.setData('Fundingchoices.selectedAccount', 'Select');
    this.selectedDepositAccount = 'Select';
  }

  _streamlineAllyAccounts() {
    const allyAccount = this.form.inputs.selectedAccount;
    let addToOptions = [];
    for (let tempAccount of this.depositAccounts) {
      const len = tempAccount.number.length;
      const nickName = tempAccount.name;
      let placeholders = [];
      for (let i = 0; i < len - 4; i++) {
        placeholders.push('*');
      };
      let accNumber = tempAccount.number.split('');
      accNumber.splice(0, len - 4, placeholders.join(''));
      const accNoShow = accNumber.join('');

      let balance = '';
      if (tempAccount.balance) {
        let asFixed = parseFloat(tempAccount.balance.replace(/[^0-9\.\-]+/g, ''));
        const isNeg = asFixed < 0 ? '-' : '';
        asFixed = Math.abs(asFixed).toFixed(2);
        const withCommas = asFixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        balance = ` (${isNeg}$${withCommas})`;
      }

      const newOption = {
        'id': tempAccount.number,
        'name': `${nickName} ${accNoShow}${balance}`
      };
      addToOptions.push(newOption);
    }

    allyAccount.options = addToOptions.concat(allyAccount.options);
  }

  _findAccount(id) {
    for (let accountObject of this.depositAccounts) {
      if (accountObject.number === id) return accountObject;
    }
  }

  _mapAccountType(type) {
    const map = {
      'DDA': 'Interest Checking',
      'MMA': 'Interest Checking',
      'SDA': 'Interest Checking'
    };
    return map[type] || type;
  }

  updateOptionValue(event) {
    this.selectAccountError = false;
    if (event.id === 'allyAccountFundingChoices') {
      if (event.showHide !== undefined) {
        this.selectedDepositAccount = this._findAccount(event.showHide.id);
      }
      this.eAccount = event.value;
    }
  }

  difFundingMethod(event) {
    this.modal.difFunding();
  }

  openPlaid() {
    this.appActions.clearData('FundAccount');
    this.appActions.setData('FundAccount.accountHoldersName', this.appInfo.signature.name);
    this.plaid.open();
  }

  btnClick(e) {
    if (e.action === 'next') {
      if (this.eAccount === 'Add a Non-Ally Account') {
        this.appActions.clearData('FundAccount');
        this.appActions.setData('FundAccount.accountHoldersName', this.appInfo.signature.name);
        return;
      }

      const selectedAccount = this.selectedDepositAccount;
      if (this.selectedDepositAccount === 'Select') {
        this.selectAccountError = true;
        return;
      }
      this.appProxy.setDepositAccount(selectedAccount, resp => {
        if (resp && resp.status === 200) {
          this.appActions.setData('FundAccount', {
            accountType: this.flowManager.getAccountType(),
            bankAccountOwnershipType: this.flowManager.getAccountType(),
            bankAccountType: this._mapAccountType(selectedAccount.type),
            routingNumber: '124003116', // Static for ally
            accountNumber: selectedAccount.number,
            bankName: 'Ally',
            name: selectedAccount.name,
            accountHoldersName: this.appInfo.signature.name,
            allyBankAccount: true,
            encryptedAccount: this.eAccount,
            fromAccountType: selectedAccount.type
          });
          this.flowManager.isOneAllyBank = true;
          this.appActions.setData('StepCompleted.achProfile', true);
          let depositRoute = this.flowManager.isIra ? 'deposit-funds-ira' : 'deposit-funds';
          this.router.navigate([depositRoute]);
        }
      });
    } else if (e.action === 'fund_later') {
      this.flowManager.ssoToAlly();
    }
  }

}